import React from "react";
import { Settings, Zap } from "react-feather";
import { Box, Tooltip } from "@mui/material";
import { Link, useLocation } from "react-router-dom";

const SidebarTapAdminButton = () => {
  const location = useLocation();
  const isActive = location.pathname.startsWith("/admin/taps");

  return (
    <Tooltip
      title="Custom Tap Admin"
      placement="right"
      arrow
      slotProps={{
        arrow: { sx: { color: "#546e7a" } },
        tooltip: {
          sx: {
            backgroundColor: "#546e7a",
            fontSize: "11px",
            padding: "6px 12px",
            borderRadius: "6px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          },
        },
      }}
    >
      <Box
        component={Link}
        to="/admin/taps"
        sx={{
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 32,
          height: 32,
          borderRadius: "6px",
          cursor: "pointer",
          color: isActive ? "#ffffff" : "rgba(233, 236, 239, 0.7)",
          backgroundColor: isActive ? "rgba(255,255,255,0.15)" : "transparent",
          transition: "all 0.15s ease-in-out",
          textDecoration: "none",
          "&:hover": {
            backgroundColor: "rgba(255,255,255,0.1)",
            color: "#ffffff",
            transform: "scale(1.04)",
          },
        }}
      >
        <Settings size={18} />
        <Zap size={11} fill="#FFD600" color="#FFD600" style={{ position: "absolute", top: 0, right: 0 }} />
      </Box>
    </Tooltip>
  );
};

export default SidebarTapAdminButton;
